import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { render } from "storyblok-rich-text-react-renderer";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { TextBannerStoryblok } from "~/generated/sb/blok-types";
import styles from "./TextBannerBlok.module.css";

export const TextBannerBlok = ({ blok, preview }: BlokProps<TextBannerStoryblok>) => {
	const blokMedia = blok?.media?.[0];

	return (
		<BlokWrap
			editable={blok}
			className={clsx(styles.wrapper, blok?.alignment === "right" && styles.right)}
			data-layout="blok"
		>
			<div className={styles.group}>
				{blokMedia && (
					<div className={styles.media}>
						<div className={styles.innermedia}>
							<StoryblokComponent blok={blokMedia} preview={preview} />
						</div>
					</div>
				)}
				<div className={styles.text}>
					<div className={styles.innertext}>
						<div className={styles.titleWrap}>
							<h2 className={styles.title}>{blok?.title}</h2>
						</div>
						<div className={styles.textWrap}>
							<div className={styles.richtext}>{render(blok?.text)}</div>
						</div>
					</div>
				</div>
			</div>
		</BlokWrap>
	);
};
